var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#EAEAEA",
    cx: 20,
    cy: 20,
    r: 19.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "transfers",
    transform: "translate(9.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,12 C12.7,12 10,14.7 10,18 C10,21.3 12.7,24 16,24 C19.3,24 22,21.3 22,18 C22,14.7 19.3,12 16,12 Z",
    id: "Shape",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#444444",
    points: "13.77 5 16.77 0 3.23 0 6.23 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,18 C8,13.59 11.59,10 16,10 C16.34,10 16.67,10.03 17,10.07 C16.12,8.89 15.19,7.82 14.42,7 L5.58,7 C3.41,9.3 0,13.49 0,17 C0,19.1 0.97,24 10,24 C10.25,24 10.46,23.98 10.7,23.98 C9.05,22.51 8,20.38 8,18 Z",
    id: "Shape",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 13,
    y: 15.45,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "17 17.95 19 15.95 17 13.95"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 15,
    y: 19.55,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "15 18.05 13 20.05 15 22.05"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfers);
export default __webpack_public_path__ + "static/media/transfers.2f9969d83e5384a6b794bbb3b55816c3.svg";
export { ForwardRef as ReactComponent };